/*
 * The combined file upload boxes english translation
 */
export const COMBINED_FILE_UPLOAD_BOX_EN = {
  dragDropOr: 'Drag and Drop or',
  selectFromFiles: 'select from files',
  addAll: 'Add All',
  transcribing: 'Transcribing...',
  upload: 'Upload',
  reset: 'Reset',
  processing: 'Processing',
  // toast translations
  maxFileSizeIs100Mb: 'Max file size is 100MB!',
  invalidFileType: 'Not a valid file type!',
  only: 'Only',
  filesAllowed: 'file(s) allowed',
  noFilesToTranscribe: 'No files to transcribe!',
  error: 'Error',
  noFilesToProcess: 'No files to process!',
  featureNotAvailable: 'Feature not available',
  errorExtractingContent: 'Error extracting content',
  errorReadingFile: 'Error reading file',
  errorProcessingFiles: 'Error processing files',
  filesFailed: 'files failed',
  successfullyProcessed: 'Successfully processed',
  files: 'files',
  dropFilesHere: 'Drop files here',
  releaseToUpload: 'Release to upload',
  fileAlreadyUploaded: 'File already uploaded',
  documents: 'Documents',
  audio: 'Audio',
  video: 'Video',
  maxMB: 'Max 100 MB',
  upTo: 'Up to',
  // error messages
  selectedFileInvalid: 'Selected file is invalid',
  // split content
  fileTooLarge: 'This file is too large to process at once',
  splitHtmlContent: 'Split into smaller parts',
  splitSuccessful: 'Content split successfully',
  splitFailed: 'Failed to split content',
  partOf: 'Part of',
  documentTooLargeUseUploadPanel:
    'Document too large. Use the Upload panel to split it into sections.',
  textTooLarge: 'Text is too large - please split first or copy manually',
  documentTooLargeSplitAvailable:
    'Document too large. Use the split button to divide it into smaller parts.',
  documentTooLargeCopyManually: 'Document too large. Please copy text portions manually.'
}
/*
 * The combined file upload boxes german translation
 */
export const COMBINED_FILE_UPLOAD_BOX_DE = {
  dragDropOr: 'Dateien hierher ziehen oder',
  selectFromFiles: 'aus Dateien auswählen',
  addAll: 'Alle hinzufügen',
  transcribing: 'Transkribiere...',
  upload: 'Hochladen',
  reset: 'Zurücksetzen',
  processing: 'Verarbeite',
  // toast translations
  maxFileSizeIs100Mb: 'Maximale Dateigröße: 100MB!',
  invalidFileType: 'Ungültiger Dateityp!',
  only: 'Nur',
  filesAllowed: 'Dateien erlaubt',
  noFilesToTranscribe: 'Keine Dateien vorhanden!',
  error: 'Fehler',
  noFilesToProcess: 'Keine Dateien vorhanden!',
  featureNotAvailable: 'Funktion nicht verfügbar',
  errorExtractingContent: 'Fehler beim Extrahieren des Inhalts',
  errorReadingFile: 'Fehler beim Lesen der Datei',
  errorProcessingFiles: 'Fehler beim Verarbeiten der Dateien',
  filesFailed: 'Dateien fehlgeschlagen',
  successfullyProcessed: 'Erfolgreich verarbeitet',
  files: 'Dateien',
  dropFilesHere: 'Dateien hier ablegen',
  releaseToUpload: 'Loslassen zum Hochladen',
  fileAlreadyUploaded: 'Datei bereits hochgeladen',
  documents: 'Dokumente',
  audio: 'Audio',
  video: 'Video',
  maxMB: 'Bis zu 100 MB',
  upTo: 'Bis zu',
  // error messages
  selectedFileInvalid: 'Ausgewählte Datei ungültig',
  // split content
  fileTooLarge: 'Diese Datei ist zu gross fuer eine Verarbeitung auf einmal',
  splitHtmlContent: 'In kleinere Teile aufteilen',
  splitSuccessful: 'Inhalt erfolgreich aufgeteilt',
  splitFailed: 'Aufteilung fehlgeschlagen',
  partOf: 'Teil von',
  documentTooLargeUseUploadPanel:
    'Dokument zu groß. Verwenden Sie das Upload-Panel, um es in Abschnitte aufzuteilen.',
  textTooLarge: 'Zu viel Text – bitte aufteilen oder manuell einfügen',
  documentTooLargeSplitAvailable:
    'Dokument zu groß. Nutzen Sie die Teilen-Funktion, um es aufzuteilen.',
  documentTooLargeCopyManually: 'Dokument zu groß. Bitte kopieren Sie Textabschnitte manuell.'
}
